import type { Currency, TransactionFilters } from "@/types";

/** Applies `/transactions?...` query keys into partial filters for the transactions list. */
export function transactionFiltersFromSearchParams(
  params: URLSearchParams,
): Partial<TransactionFilters> {
  const out: Partial<TransactionFilters> = {};
  const c = params.get("currency");
  if (c === "USD" || c === "ILS" || c === "EUR") out.currency = c as Currency;
  const df = params.get("dateFrom");
  if (df) out.dateFrom = df;
  const dt = params.get("dateTo");
  if (dt) out.dateTo = dt;
  const t = params.get("type");
  if (t === "income" || t === "expense") out.type = t;
  const cat = params.get("categoryId");
  if (cat) out.categoryId = cat;
  const sub = params.get("subcategoryId");
  if (sub) out.subcategoryId = sub;
  const search = params.get("search");
  if (search) out.search = search;
  return out;
}
